export const ArrowDownRight = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.4" d="M10 26V24H22.59L6 7.41L7.41 6L24 22.59V10H26V26H10Z" fill="currentColor"/>
<path d="M25 10V25H10" stroke="currentColor" stroke-width="2"/>
<path d="M6.69379 6.69379L25 25" stroke="currentColor" stroke-width="2"/>
</svg>`;
